import { render, staticRenderFns } from "./ProductManagementBody.vue?vue&type=template&id=1823e1eb&scoped=true&"
import script from "./ProductManagementBody.vue?vue&type=script&lang=ts&"
export * from "./ProductManagementBody.vue?vue&type=script&lang=ts&"
import style0 from "./ProductManagementBody.vue?vue&type=style&index=0&id=1823e1eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1823e1eb",
  null
  
)

export default component.exports